import { render, staticRenderFns } from "./FormTrainer.vue?vue&type=template&id=d997a3e8&"
import script from "./FormTrainer.vue?vue&type=script&lang=js&"
export * from "./FormTrainer.vue?vue&type=script&lang=js&"
import style0 from "./FormTrainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports